import { useState, useEffect } from 'react';
import useVrackApi from './useVrackApi';

export default function useGetMOTD() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const { fetchData: vrackApiGetMOTD } = useVrackApi('get', '/racks/motd/none', true);

  const getMOTD = async () => {
    await vrackApiGetMOTD()
      .then((response) => {
        console.debug(`Response from the MOTD endpoint: ${JSON.stringify(response.motd)}`);
        setMessage(response.motd);
      })
      .catch((error) => {
        setError(error);
        console.error('Failed to get the rack MOTD', error);
      });
  };
  useEffect(() => {
    getMOTD();
    // eslint-disable-next-line
  }, []);
  return { message, error, getMOTD };
}
